/** Displace — warp the mark with a sine field. */
import type { AffectModule } from '../../core/module-api';
import { cfgNum } from '../../core/module-api';
import { cloneShape } from '../../core/scene';
import { transformPath } from '../../core/geometry';

const ICON =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 8c3 0 3 4 6 4s3-4 6-4 3 4 6 4"/><path d="M2 16c3 0 3-4 6-4s3 4 6 4 3-4 6-4"/></svg>';

export function createDisplace(): AffectModule {
  return {
    manifest: {
      id: 'displace',
      kind: 'affect',
      name: 'Displace',
      apiVersion: 1,
      description: 'Warp the mark through a wavy displacement field.',
      icon: ICON,
      params: [
        { kind: 'slider', key: 'amount', label: 'Amount', min: 0, max: 40, step: 1, default: 12 },
        { kind: 'slider', key: 'scale', label: 'Scale', min: 2, max: 60, step: 1, default: 16 },
      ],
    },

    affect(shapes, ctx) {
      const amt = cfgNum(ctx.config, 'amount', 12);
      if (amt <= 0) return shapes.slice();
      const k = 1 / Math.max(2, cfgNum(ctx.config, 'scale', 16));
      return shapes.map((s) => {
        const c = cloneShape(s);
        c.path = transformPath(s.path, (p) => ({
          x: p.x + Math.sin(p.y * k) * amt,
          y: p.y + Math.sin(p.x * k) * amt,
        }));
        return c;
      });
    },
  };
}
